import classNames from 'classnames';
import React from 'react';

import {ProvidedEnzyme} from 'constants/SequenceConstants';
import {EnzymeAttributes} from 'molbio/enzymes/backbone/Enzymes';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

interface Enzyme extends Omit<EnzymeAttributes, 'isoschizomers'> {
  isoschizomers: Array<EnzymeAttributes>;
}

export interface EnzymePreviewProps {
  enzyme: Enzyme;
  hideJump: boolean;
  providedEnzyme: ProvidedEnzyme;
}

function EnzymePreview({enzyme, hideJump, providedEnzyme}: EnzymePreviewProps): JSX.Element {
  return (
    <div>
      <div>
        <span className="close">&times;</span>
      </div>
      <h5>Enzyme {enzyme.name}</h5>
      <div className="cut-info-wrapper">
        <div className="cut-info mono" />
      </div>
      <div className="js-enzyme-provider" />
      <dl className="enzyme-popover-info">
        {providedEnzyme.url && (
          <>
            <dt>Link</dt>
            <dd>
              <a href={providedEnzyme.url} rel="noopener noreferrer" target="_blank" className="enzyme-link">
                {providedEnzyme.baseName}
              </a>
            </dd>
          </>
        )}
        <dt>Inactivation</dt>
        <dd>
          {providedEnzyme.inactivationTemperature != null ? (
            <>{providedEnzyme.inactivationTemperature}&deg;C</>
          ) : (
            'N/A'
          )}
        </dd>
        <dt>Incubation</dt>
        <dd>
          {providedEnzyme.incubationTemperature != null ? (
            <>{providedEnzyme.incubationTemperature}&deg;C</>
          ) : (
            'N/A'
          )}
        </dd>
        <dt>Activity</dt>
        <dd>
          <table className="table table-condensed table-bordered enzyme-preview-table">
            {providedEnzyme.activityRows.map((activityRow, i) => (
              <React.Fragment key={i}>
                <tr>
                  {activityRow.map((activity, j) => (
                    <th key={j} className={classNames({'is-highlighted': activity.highlighted})}>
                      {activity.buffer}
                    </th>
                  ))}
                </tr>
                <tr>
                  {activityRow.map((activity, j) => (
                    <td key={j} className={classNames({success: activity.highlighted})}>
                      {activity.value}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </table>
        </dd>
        <dt>Isos.</dt>
        <dd>
          {enzyme.isoschizomers.length > 0 ? (
            <ul className="enzyme-isoschizomers">
              {enzyme.isoschizomers.map((isoEnzyme) => (
                <li key={isoEnzyme.id}>
                  <a data-enzymeId={isoEnzyme.id}>{isoEnzyme.name}</a>
                </li>
              ))}
            </ul>
          ) : (
            'None'
          )}
        </dd>
        {enzyme.cutPositions.length > 0 && !hideJump && (
          <>
            <dt>Jump to Cut Site</dt>
            <div className="cut-positions">
              <table className="table table-condensed table-hover" />
            </div>
          </>
        )}
      </dl>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<EnzymePreviewProps>(EnzymePreview);
